import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

export const AuthImage = ({ creationId, alt, className, testid }) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get(`/creations/${creationId}/file`, { responseType: "blob" })
      .then(({ data }) => {
        if (cancelled) return;
        if (ref.current) URL.revokeObjectURL(ref.current);
        ref.current = URL.createObjectURL(data);
        setUrl(ref.current);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [creationId]);

  useEffect(() => () => {
    if (ref.current) URL.revokeObjectURL(ref.current);
  }, []);

  if (failed) {
    return (
      <span className={`flex items-center justify-center bg-page ${className}`}>
        <ImageOff className="h-5 w-5 text-ink-soft" />
      </span>
    );
  }

  if (!url) {
    return (
      <span className={`flex items-center justify-center bg-page ${className}`}>
        <Loader2 className="h-5 w-5 animate-spin text-brand" />
      </span>
    );
  }
  return <img data-testid={testid} src={url} alt={alt} className={className} />;
};
